import "../../../resources/less/Family/ThemePages/EnchantedDesert.less";
import BaseThematique from "./BaseThematique";

class EnchantedDesert extends BaseThematique {
  constructor() {
    super();
  }
}

$(window).on("load", () => {
  new EnchantedDesert();
});
